export default {
  toasts: {
    auth_token_invalid: 'Virheellinen todennustunnus',
    host_access_refused:
      'Tämä osoite kuuluu kumppanille, jonka osana tilisi ei ole. Kirjaudu sisään omalla osoitteellasi.',
  },
};
